module.exports = __webpack_public_path__ + "static/20230619_192-d04037a1a69852c9d23c30c410a48f05.jpg";